import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';
import { ArrowLeft, Building2, CheckCircle } from 'lucide-react';
import api from '../../services/api';

export default function GerarDeUnidade() {
  const navigate = useNavigate();
  const [empId, setEmpId] = useState('');
  const [unidadeId, setUnidadeId] = useState('');

  const { data: empreendimentos } = useQuery({
    queryKey: ['empreendimentos'],
    queryFn: () => api.get('/empreendimentos').then(r => r.data.data),
  });

  const { data: unidades } = useQuery({
    queryKey: ['unidades-gerar', empId],
    queryFn: () => api.get('/unidades', { params: { empreendimento_id: empId } }).then(r => r.data.data),
    enabled: !!empId,
  });

  const mutGerar = useMutation({
    mutationFn: () => api.post(`/imoveis/gerar-de-unidade/${unidadeId}`),
    onSuccess: (res) => navigate(`/imoveis/${res.data.data.id}`),
  });

  const unidadesDisp = (unidades || []).filter(u => u.status === 'disponivel');

  return (
    <div className="max-w-lg space-y-6">
      <div className="flex items-center gap-4">
        <button onClick={() => navigate('/imoveis')} className="text-gray-400 hover:text-gray-700"><ArrowLeft size={20} /></button>
        <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
          <Building2 size={22} className="text-secondary" /> Gerar Imóvel de Unidade
        </h1>
      </div>

      <div className="bg-white rounded-xl shadow p-6 space-y-5">
        <p className="text-sm text-gray-500">Selecione uma unidade disponível para gerar automaticamente um imóvel com os dados do empreendimento.</p>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Empreendimento</label>
          <select
            value={empId}
            onChange={e => { setEmpId(e.target.value); setUnidadeId(''); }}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-secondary"
          >
            <option value="">Selecione...</option>
            {(empreendimentos || []).map(e => <option key={e.id} value={e.id}>{e.nome}</option>)}
          </select>
        </div>

        {empId && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Unidade Disponível</label>
            {unidadesDisp.length === 0 ? (
              <p className="text-sm text-gray-400">Nenhuma unidade disponível neste empreendimento.</p>
            ) : (
              <select
                value={unidadeId}
                onChange={e => setUnidadeId(e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-secondary"
              >
                <option value="">Selecione a unidade...</option>
                {unidadesDisp.map(u => (
                  <option key={u.id} value={u.id}>
                    {u.identificador}{u.torre ? ` - Torre ${u.torre}` : ''}{u.andar ? ` · ${u.andar}º andar` : ''}{u.preco ? ` · R$ ${Number(u.preco).toLocaleString('pt-BR')}` : ''}
                  </option>
                ))}
              </select>
            )}
          </div>
        )}

        {mutGerar.isError && (
          <p className="text-sm text-red-600 bg-red-50 rounded-lg p-3">
            {mutGerar.error?.response?.data?.error || 'Erro ao gerar imóvel'}
          </p>
        )}

        <button
          onClick={() => mutGerar.mutate()}
          disabled={!unidadeId || mutGerar.isPending}
          className="w-full flex items-center justify-center gap-2 py-3 bg-primary text-white rounded-lg text-sm font-medium hover:bg-secondary disabled:opacity-50"
        >
          <CheckCircle size={16} />
          {mutGerar.isPending ? 'Gerando...' : 'Gerar Imóvel'}
        </button>
      </div>
    </div>
  );
}
